import { pick } from "lodash";
import React from "react";
import UIActions from "../../../actions/UIActions";
import AppConfig from "../../../config/app";
import AppConstants from "../../../constants/AppConstants";
import Modal from "../../base/Modal";
import CreateAccountForm from "./CreateAccountForm/CreateAccountForm.jsx";

import styles from "./SignupModal.module.css";

const SignupModal = (props) => {
  const { cancelAction = null } = props;

  const _cancel = () => {
    cancelAction && cancelAction();
    UIActions.modalClose(AppConstants.MODAL_SIGNUP);
  };

  const modalProps = pick(props, Modal.BASIC_PROPS);

  return (
    <Modal
      {...modalProps}
      backdrop={true}
      backdropClassName={styles.backdrop}
      flex
      onHide={_cancel}
    >
      <Modal.Dialog className={styles.dialog} contentClassName={styles["dialog-content"]}>
        <div className={styles["form-wrapper"]}>
          <CreateAccountForm action={AppConfig.createAccountURL} method="get" />
        </div>
      </Modal.Dialog>
    </Modal>
  );
};

export default SignupModal;
